/**
 * Labels for TableSheet row actions in ReactGrid context menu.
 * Sửa tại đây để đổi text (JP / EN / …).
 */
export const tableSheetContextMenuLabels = {
  insertRowsAbove: (rowCount: number) => `上に${rowCount}行を挿入`,
  insertRowsBelow: (rowCount: number) => `下に${rowCount}行を挿入`,
  deleteRows: "行を削除",
};
